import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { PolicyHolderPropTypes } from '../../../../propTypes/petDetails';
import ContactType from './contactType';
import { CSPUrlsMap } from '../../../../routes/CSPUrlsMap';
import useStepupChallenge from '../../../../hooks/useStepupChallenge';
import { BrandContext } from '../../../../contextProviders/brandContext';
import { UpdateContactDetailsPopup } from './updateContactDetailsModal';
import { AUTHENTICATION_TYPES } from '../../../../constants/constants';
import { SuccessMessageDialog } from '../../../successMessage/successMessageDialog';

export const ContactDetails = ({ policyHolder, numPolicyHolders = 1 }) => {
  const { authenticationType } =
    useContext(BrandContext).activeBrandContext.cspConfiguration.auth0Config[process.env.REACT_APP_ENV];
  const isSsoAuthentication = authenticationType === AUTHENTICATION_TYPES.SSO;
  const [showContactDetailsModal, setShowContactDetailsModal] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const { stepUpSmsChallenge } = useStepupChallenge();
  const { email, phoneMobile, policyNumber } = policyHolder;

  const handleEmailUpdate = () => {
    if (isSsoAuthentication) {
      setShowContactDetailsModal(true);
    } else {
      stepUpSmsChallenge(`${window.location.origin}${CSPUrlsMap.updateEmail.url}`, true);
    }
  };

  const handleMobileUpdate = () => {
    if (isSsoAuthentication) {
      setShowContactDetailsModal(true);
    } else {
      stepUpSmsChallenge(`${window.location.origin}${CSPUrlsMap.updateMobile.url}`, true);
    }
  };

  return (
    <div className="policyHolderDetail">
      <h3>{numPolicyHolders === 1 ? 'My contact details' : 'Contact details'}</h3>
      <ContactType
        label="Email"
        value={email}
        handleUpdate={handleEmailUpdate}
      />
      <ContactType
        label="Mobile"
        value={phoneMobile}
        handleUpdate={handleMobileUpdate}
      />

      {showContactDetailsModal && (
        <UpdateContactDetailsPopup
          policyHolder={policyHolder}
          setShowContactDetailsModal={setShowContactDetailsModal}
          setShowSuccessMessage={setShowSuccessMessage}
        />
      )}

      {showSuccessMessage && (
        <SuccessMessageDialog
          message="Thanks, your details will be updated. Please refresh your page in a moment to view the changes."
          onClose={() => setShowSuccessMessage(false)}
        />
      )}
    </div>
  );
};

ContactDetails.propTypes = {
  policyHolder: PolicyHolderPropTypes,
  numPolicyHolders: PropTypes.number
};
